import React, { useState, useEffect } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { shoppersFactory } from '../../services/PostsService';
import tabDataUsers from './subtabs/tabDataUsers.json'
import SimplePagination from "../components/pagination/Paginations"
import { Modal } from 'react-bootstrap';
import { filterShops, approveStore, rejectStore, inactivateStore } from '../../services/UserService'
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { createStore } from "../../store/actions/AuthActions";
import ReCAPTCHA from 'react-google-recaptcha';

const tabData = tabDataUsers

function PartnersList() {
  const [products, setProducts] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(null);

  const [modalSearch, setModalSearch] = useState(false);
  const [modalManagerStore, setModalManagerStore] = useState(false);
  const [modalNewStore, setModalNewStore] = useState(false);

  const [objManaged, setObjManaged] = useState({});
  const [productNameSearch, setProductNameSearch] = useState('');
  const [onSearch, setOnSearch] = useState(false);
  const [lastSearch, setLastSearch] = useState('');
  const [searchSteps, setSearchSteps] = useState('name');

  const [searchValueType, setValueType] = useState('name');

  useEffect(() => {
    if (products.length === 0 && !trigger) {
      const fetchProducts = async () => {
        try {
          const response = await shoppersFactory(1, 20);
          if (response.status === 200) {
            setProducts(response.data.result)
            setTotalItems(response.data.totalPage)
          } else {

          }
        } catch (error) {

        }
      };
      setTrigger(true)
      fetchProducts();
    }
  }, [products]);

  const handlePageChange = (page) => {
    const fetchShoppers = async () => {
      try {
        const response = await shoppersFactory(page, 20);
        if (response.status === 200) {
          setProducts(response.data.result);
          setTotalItems(response.data.totalPage)
          setCurrentPage(page)
        } else {

        }
      } catch (error) {

      }
    };
    fetchShoppers();
  };

  const gerenciarStore = (obj) => {
    setModalManagerStore(true)
    setObjManaged(obj)
  }

  const handleStoreFilter = (searchValueType, value) => {

    const storeFilter = async () => {

      try {
        const response = await filterShops(value, searchValueType, currentPage, 20);
        if (response.status === 200) {
          setProducts(response.data.result);
          setOnSearch(true);
          setLastSearch(value);
          setModalSearch(false);
        }
      } catch (error) {
        console.error("Erro ao  filtrar as lojas:", error);
      }
    };
    storeFilter();
  }

  return (
    <>
      <div className="custom-tab-1 pb-3">
        <Tab.Container defaultActiveKey={tabData[1].name.toLowerCase()}>
          <Nav as="ul" className="navigatore justify-content-center">
            {tabData.map((data, i) => (
              <Nav.Item as="li" key={i}>
                <Nav.Link eventKey={data.name.toLowerCase()} href={data.link}>
                  <i className={`la la-${data.icon} me-2`} />
                  {data.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Tab.Container>
      </div>
      <div className="row">
        <div className="col-xl-12 pt-3">
          <div>
            <div id="customers"
              className="row"
              style={{
                width: "100%",
                padding: 0,
                justifyContent: 'center'
              }}
            >
              <span style={{ gap: '5px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', alignContent: 'center', gap: 5, width: '100%' }}>
                
              {!onSearch ?
                  <button className="btn btn-primary-outline border-primary text-primary" onClick={() => setModalSearch(true)}>
                    procurar loja
                  </button>
                : onSearch ?
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' , gap: '8px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>                      <label><i className="fa-solid fa-magnifying-glass"></i> buscando por:</label>
                      <h4 style={{ backgroundColor: 'rgb(241, 241, 241)', padding: "6px 17px" }}><b className="text-primary">{lastSearch}</b></h4>
                    </div>
                    <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', alignContent: 'center', gap: 5 }}>
                      <button className="btn btn-primary-outline border-primary text-primary" onClick={() => setModalSearch(true)}>
                        procurar nova loja
                      </button>
                    </span>
                  </div>
                  : null
              }
              <button className="btn btn-primary-outline border-primary text-primary" onClick={() => setModalNewStore(true)}>
                cadastrar loja
              </button>
              </span>
              <ul className="btn-reveal-trigger row" style={{
                width: "100%",
                padding: 0
              }}>
                {products.map((Data, index) => (

                  <li className="col-md-4"
                    style={{
                      marginBottom: 6,
                      borderRadius: 6,
                    }} key={index}>
                    <div
                      className="p-3"
                      style={{
                        boxShadow: '2px 2px 2px #f1f1f1',
                      }}>
                      <span style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        {
                          Data.images.length === 0 ? (
                            <span style={{
                              width: '100%',
                              height: 120,
                              backgroundImage: "gray",
                              margin: '0 auto',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center', gap: 2, backgroundColor: 'rgb(241 241 241)'
                            }}>
                              <i className='bi bi-shop' style={{ fontSize: 45, color: 'white' }} />
                            </span>
                          ) : <img className="" style={{ width: '100%' }} src={'https://core.pskeromais.com.br/' + Data.images[0].url} />
                        }
                        <div className="media d-flex align-items-center">
                          <div>
                            <br />
                            <div className="media d-flex justify-content-between">
                              <h4 className="mb-0 fs--1">
                                {Data.name}
                              </h4>
                            </div>
                          </div>
                        </div>
                        {
                          Data.status === 0 ?
                            <span className='btn btn-outline-secondary text-secondary' style={{ with: '70px', margin: '5px 0', color: 'white', textAlign: 'center' }}>
                              pendente
                            </span>
                            : Data.status === 1 ?
                              <span className='btn btn-outline-success  text-success' style={{ with: '70px', margin: '5px 0', color: 'white', textAlign: 'center' }}>
                                aprovado
                              </span>
                              : Data.status === 2 ?
                                <span className='btn btn-outline-danger  text-danger' style={{ with: '70px', margin: '5px 0', color: 'white', textAlign: 'center' }}>
                                  rejeitado
                                </span>
                                : Data.status === 3 ?
                                  <span className='btn btn-outline-dark  text-dark' style={{ with: '70px', margin: '5px 0', color: 'white', textAlign: 'center' }}>
                                    cancelado
                                  </span>
                                  :
                                  null
                        }
                        <span style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <span className='d-flex flex-wrap'>
                            <hr style={{ width: '100%' }} />
                            <ul>
                              <li style={{ fontSize: '15px', wordBreak: 'break-word' }}>
                                <i class="bi bi-person-badge"></i> {formatCNPJ(Data.taxId)}
                              </li>
                              <li style={{ fontSize: '15px', wordBreak: 'break-word' }}>
                                <i class="bi bi-telephone"></i> {formatPhone(Data.phone)}
                              </li>
                              <li style={{ fontSize: '15px', wordBreak: 'break-word' }}>
                                <i class="bi bi-geo-alt"></i>
                                {
                                  " " +
                                  Data.addresses[0].street + ' , ' +
                                  Data.addresses[0].number + ' , ' +
                                  Data.addresses[0].neighborhood + ' , ' +
                                  Data.addresses[0].city + ' -  (' +
                                  Data.addresses[0].state + ')'
                                }
                              </li>
                            </ul>
                          </span>
                        </span>
                      </span>
                      <hr style={{ margin: '8px 0' }} />
                      <span style={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                        <a
                          className="btn btn-primary py-1 px-3 mt-2"
                          onClick={() => gerenciarStore(Data)}
                        >
                          gerenciar
                        </a>
                        <a
                          className="btn btn-secondary py-1 px-3 mt-2"
                          href={`/editar-parceiro?p=${Data.id}`}
                        >
                          editar
                        </a>
                        {/* <a href={`/parceiro?p=${Data.id}`} className="btn btn-light py-1 px-3 mt-2" style={{ maxWidth: 100 }}>
                          ver +
                        </a> */}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-12">
          {
            products.length > 0 ?
              <SimplePagination
                totalItems={totalItems}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
              : null
          }
        </div>
      </div>
      <Modal show={modalSearch}>
        <button onClick={() => setModalSearch(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
          <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
        </button>
        <span
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'spaceBetween',
            width: '100%',
            margin: '10px 0',
            justifyContent: 'space-around',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <span
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
              justifyContent: 'spaceBetween',
              justifyContent: 'space-around',
              padding: '14px',
              justifyContent: 'center',
              gap: '10px',
              border: '1px #f6f6f6 solid'
            }}
          >
            <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
              <h5 className="" style={{ margin: 0 }}><i className="fa-solid fa-magnifying-glass"></i></h5>
              <h5 className="text-primary" style={{ margin: 0 }}>Pesquisar Loja</h5>
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
              {searchSteps === 'name' ?
                <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                  <input onChange={(e) => setProductNameSearch(e.target.value)} placeholder="pesquisar por nome" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                  <button className={`btn btn-light`} style={{ fontSize: 12 }} onClick={() => handleStoreFilter(searchValueType, productNameSearch)}>buscar</button>
                </span>
                : searchSteps === 'address' ?
                  <span style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                    <span style={{ display: 'flex', flexDirection: 'row' }}>
                      <input placeholder="pesquisar por endereço" style={{ width: '100%', padding: '2px 5px', textAlign: 'center', height: 40 }} />
                      <select style={{ width: '120px', textAlign: 'center', height: 40, color: 'gray' }}>
                        <option onChange={(e) => { setValueType('street') }} >rua</option>
                        {/* <option>número</option> */}
                        <option onChange={(e) => setValueType('neighborhood')}>bairro</option>
                        <option onChange={(e) => setValueType('city')}>cidade</option>
                      </select>
                    </span>
                    <button className={`btn btn-light`} style={{ fontSize: 12 }} onClick={() => handleStoreFilter(searchValueType, productNameSearch)}>buscar</button>
                  </span>
                  : null}
            </span>
            <span style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center', gap: 5 }}>
              <button className={`btn ${searchSteps === 'name' ? 'btn-primary-outline text-primary' : 'btn-primary text-light'} border border-primary`} style={{ fontSize: 12 }} onClick={() => setSearchSteps('name')}>nome</button>
              <button className={`btn ${searchSteps === 'address' ? 'btn-primary-outline text-primary' : 'btn-primary text-light'} border border-primary`} style={{ fontSize: 12 }} onClick={() => setSearchSteps('address')}>endereço</button>
            </span>
          </span>
        </span>
      </Modal>
      <Modal className="modal fade" show={modalManagerStore} style={{ zIndex: "100 ! important", position: 'fixed' }}>
        <button onClick={() => setModalManagerStore(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
          <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
        </button>
        <span
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'spaceBetween',
            width: '100%',
            margin: '10px 0',
            justifyContent: 'space-around',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <span
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
              justifyContent: 'spaceBetween',
              justifyContent: 'space-around',
              padding: '14px',
              justifyContent: 'center',
              gap: '10px',
              border: '1px #f6f6f6 solid'
            }}
          >
            <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
              <h5 className="" style={{ margin: 0 }}><i className="bi bi-shop"></i></h5>
              <h5 className="text-primary" style={{ margin: 0 }}>Gerenciar loja</h5>
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8, textAlign: 'center' }}>
              {objManaged ?
                <span style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 5 }}>
                  <h3>{objManaged.name}</h3>
                  <span style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <span className='d-flex flex-wrap'>
                      <ul style={{ display: 'flex', flexDirection: 'column', gap: 6, textAlign: 'center', width: "100%" }}>
                        <li style={{ fontSize: '15px', fontWeight: 'bold', wordBreak: 'break-word' }}>
                          {objManaged.email}
                        </li>
                        <li style={{ fontSize: '15px', fontWeight: 'bold', wordBreak: 'break-word' }}>
                          {objManaged.phone}
                        </li>
                      </ul>
                    </span>
                  </span>
                </span>
                : null}
            </span>

            {objManaged.status === 0 ?
              <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 3, marginTop: 15 }}>
                <button onClick={() => (approveStore(objManaged.id), setModalManagerStore(false))} className='btn btn-primary'>
                  aprovar
                </button>
                <button onClick={() => (rejectStore(objManaged.id), setModalManagerStore(false))} className='btn btn-primary'>
                  rejeitar
                </button>
              </span>
              : objManaged.status === 1 ?
                <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 3 }}>
                  <button onClick={() => (inactivateStore(objManaged.id), setModalManagerStore(false))} className='btn btn-primary'>
                    inativar
                  </button>
                </span>
                : null
            }
          </span>
        </span>
      </Modal>
      <Modal show={modalNewStore}>
        <button onClick={() => setModalNewStore(false)} className='btn btn-light p-1' style={{ width: 30, height: 30, position: 'absolute', right: 6, top: 6, borderRadius: '100%' }}>
          <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
        </button>
        <span
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'spaceBetween',
            width: '100%',
            margin: '10px 0',
            justifyContent: 'space-around',
            justifyContent: 'center',
            alignContent: 'center'
          }}
        >
          <span
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'column',
              justifyContent: 'spaceBetween',
              justifyContent: 'space-around',
              padding: '14px',
              justifyContent: 'center',
              gap: '10px',
              border: '1px #f6f6f6 solid'
            }}
          >
            <span style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
              <h5 className="" style={{ margin: 0 }}><i className="fa-solid fa-magnifying-glass"></i></h5>
              <h5 className="text-primary" style={{ margin: 0 }}>Cadastrar nova loja</h5>
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
              <Register />
            </span>
          </span>
        </span>
      </Modal>
    </>
  )
}
export default PartnersList;

// Função para formatar CNPJ
function formatCNPJ(cnpj) {
  if (!cnpj) return '';
  const digits = cnpj.replace(/\D/g, '');
  return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
}

// Função para formatar telefone (8 ou 9 dígitos) e remover +55 ou 55
function formatPhone(phone) {
  if (!phone) return '';
  let digits = phone.replace(/\D/g, '');

  // Remove código do país 55 se existir
  if (digits.startsWith('55')) digits = digits.slice(2);

  // Remove o primeiro 9 caso venha duplicado (ex: 5599...)
  if (digits.length > 11 && digits.startsWith('9')) digits = digits.slice(1);

  // Formata com DDD
  if (digits.length === 10) {
    // formato fixo (8 dígitos)
    return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  } else if (digits.length === 11) {
    // formato celular (9 dígitos)
    return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  } else {
    return phone;
  }
}

function Register(props) {
  const [dataForm, setDataForm] = useState({
    name: "",
    phone: "",
    taxId: "",
    birthDate: "",
    username: "",
    password: "",
    email: "email@email.com",
    images: [],
    address: {
      number: "",
      street: "",
      city: "",
      state: "",
      zipcode: "",
      neighborhood: ""
    },
    captcha: ""
  });

  const [formattedValues, setFormattedValues] = useState({
    phone: "",
    taxId: "",
    zipcode: ""
  });

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [showAddressFields, setShowAddressFields] = useState(false);

  const formatPhone = (value) => {
    const numbers = value.replace(/\D/g, "");
    let formatted = numbers;
    if (numbers.length <= 11) {
      formatted = numbers.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
    }
    return formatted;
  };

  const formatCNPJ = (value) => {
    const numbers = value.replace(/\D/g, "");
    return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5");
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    const formattedPhone = formatPhone(value);
    setFormattedValues({ ...formattedValues, phone: formattedPhone });

    let cleanNumber = value.replace(/\D/g, "");

    if (cleanNumber.length > 2) {
      const ddd = cleanNumber.substring(0, 2);
      const rest = cleanNumber.substring(2);
      if (rest.startsWith('9')) {
        cleanNumber = ddd + rest.substring(1);
      }
    }

    const phoneForPayload = cleanNumber.length > 0 ? `55${cleanNumber}` : "";
    setDataForm({ ...dataForm, phone: phoneForPayload });
  };

  const handleCNPJChange = (e) => {
    const { value } = e.target;
    const formattedCNPJ = formatCNPJ(value);
    setFormattedValues({ ...formattedValues, taxId: formattedCNPJ });

    const cleanNumber = value.replace(/\D/g, "");
    setDataForm({ ...dataForm, taxId: cleanNumber });
  };

  const sendCreateStore = async () => {
    try {
      const formattedData = formatData(dataForm);
      const response = await createStore(formattedData);

      if (response.status === 200) {
        alert("Cadastro realizado com sucesso!");
      } else {
        alert("Erro ao realizar cadastro. Tente novamente.");
      }
    } catch (error) {
      console.error("Error creating store:", error);
    }
  };

  const formatData = (formData) => {
    return {
      ...formData,
      address: {
        ...formData.address,
        country: "Brasil"
      }
    };
  };

  const onRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    setDataForm({ ...dataForm, ['captcha']: token });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setDataForm({
      ...dataForm,
      [name]: value,
      ...(name === "phone" && { username: value, password: value }),
    });
  };

  const MapAddress = ({ lat, lng, onMove }) => {
    useMapEvents({
      moveend: (e) => {
        const center = e.target.getCenter();
        onMove(center); // devolve lat/lng atualizados
      }
    });

    return (
      <>
        <Marker position={[lat, lng]} />
      </>
    );
  }

  const AddressMap = ({ lat, lng, onUpdate }) => {
    return (
      <MapContainer center={[lat, lng]} zoom={16} style={{ height: 250, width: '100%' }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MapAddress lat={lat} lng={lng} onMove={onUpdate} />
      </MapContainer>
    );
  }

  useEffect(() => {
    if (dataForm.phone) {
      setDataForm((prev) => ({
        ...prev,
        username: prev.phone,
        password: prev.phone,
      }));
    }
  }, [dataForm.phone]);

  return (

    <div className="col-md-12 mr-auto ml-auto" style={{ maxWidth: 700 }}>
      <div style={{ backgroundColor: 'white' }}>
        <div>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="mb-3">
              <h4>Dados Básicos</h4>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">Nome da Loja</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={dataForm.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">Telefone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    value={formattedValues.phone}
                    onChange={handlePhoneChange}
                    maxLength={15}
                    placeholder="(00) 00000-0000"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">CNPJ</label>
                  <input
                    type="text"
                    className="form-control"
                    name="taxId"
                    value={formattedValues.taxId}
                    onChange={handleCNPJChange}
                    maxLength={18}
                    placeholder="00.000.000/0000-00"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="row">
                <h4>Endereço</h4>
                <AddressAutocompleteOSM
                  onSelectAddress={(addr) => {
                    setDataForm({
                      ...dataForm,
                      address: {
                        ...dataForm.address,
                        ...addr
                      }
                    });
                    setShowAddressFields(true);
                  }}
                />
              </div>
              {showAddressFields && (
                <div className="row">
                  <div className="col-md-12 mt-2 mb-3" style={{ display: 'flex' }}>
                    <hr className="mb-3 mt-3" style={{ width: 'Calc(50% - 15px)' }} />
                    <div className="w-100 text-center pt-2"><b>confirmar endereço</b></div>
                    <hr className="mb-3 mt-3" style={{ width: 'Calc(50% - 15px)' }} />

                  </div>
                  <div className="col-md-12 mt-2 mb-3">
                    <AddressMap
                      lat={parseFloat(dataForm.address.latitude)}
                      lng={parseFloat(dataForm.address.longitude)}
                      onUpdate={(pos) => {
                        setDataForm({
                          ...dataForm,
                          address: {
                            ...dataForm.address,
                            latitude: pos.lat,
                            longitude: pos.lng,
                          },
                        });
                      }}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Rua</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="street"
                    >
                      {dataForm.address.street}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Número</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="number"
                    >
                      {dataForm.address.number}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Bairro</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="neighborhood"
                    >
                      {dataForm.address.neighborhood}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Cidade</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="city"
                    >
                      {dataForm.address.city}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Estado</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="state"
                    >
                      {dataForm.address.state}
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">CEP</label>
                    <div
                      style={{ backgroundColor: "rgb(233 233 233)", width: '100%', border: 0, borderRadius: 3 }}
                      className="py-3 px-1 text-center"
                      name="zipcode"
                    >
                      {dataForm.address.zipcode}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="mb-3 d-flex justify-content-center">
              <ReCAPTCHA
                sitekey={"6LdLwaQqAAAAAL4Ktttukdp8qXT5pcHHd4PFbtOS"}
                onChange={onRecaptchaChange}
              />
            </div>

            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary"
                disabled={!recaptchaToken}
                onClick={() => sendCreateStore()}
              >
                Cadastrar Loja
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  );
}

const AddressAutocompleteOSM = ({ onSelectAddress }) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const extractNumberFromQuery = (input) => {
    // Regex para pegar primeiro número no input
    const match = input.match(/\b\d+\b/);
    return match ? match[0] : "";
  };

  const removeNumberFromQuery = (input, number) => {
    if (!number) return input;
    // Remove apenas a primeira ocorrência do número
    return input.replace(number, "").replace(/\s{2,}/g, " ").trim();
  };

  const searchAddress = async () => {
    if (!query || query.length < 3) {
      setSuggestions([]);
      return;
    }
    setLoading(true);
    const number = extractNumberFromQuery(query);
    const queryWithoutNumber = removeNumberFromQuery(query, number);

    try {
      const response = await fetch(
        `https://bot.pskeromais.com.br/api/street-founder?q=${encodeURIComponent(
          queryWithoutNumber
        )}`
      );
      const data = await response.json();
      setSuggestions(Array.isArray(data) ? data : []);
      // abre o modal com os resultados
      setShowModal(true);
    } catch (error) {
      console.error("Erro ao buscar endereço OSM:", error);
      setSuggestions([]);
      setShowModal(true); // abre modal mesmo que vazio (pode exibir "Nenhum endereço")
    } finally {
      setLoading(false);
    }
  };

  const formatAddress = (item, number = "") => {
    const addr = item.address || {};
    return [
      [addr.road, number || addr.house_number].filter(Boolean).join(", "), // rua + número
      addr.suburb, // bairro
      addr.city || addr.town || addr.village, // cidade
      addr.state, // estado
      addr.postcode, // CEP
      addr.country, // país
    ]
      .filter(Boolean)
      .join(", ");
  };

  const handleSelect = (item) => {
    const number = extractNumberFromQuery(query); // pega o número que o usuário digitou
    const formatted = formatAddress(item, number);
    setQuery(formatted);
    setSuggestions([]);

    const { address, lat, lon } = item;
    const payload = {
      number: number || address.house_number || "",
      street: address.road || "",
      city: address.city || address.town || address.village || "",
      state: address.state || "",
      zipcode: address.postcode || "",
      neighborhood: address.suburb || "",
      country: 'Brasil',
      latitude: lat,
      longitude: lon,
    };

    onSelectAddress(payload);
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ display: "flex", gap: 6 }}>
        <input
          type="text"
          className="form-control"
          placeholder="Digite seu endereço"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={searchAddress}
          disabled={query.length < 3 || loading}
          title="Buscar endereço"
        >
          <i className="bi bi-search" />
        </button>
      </div>

      {loading && <div style={{ marginTop: 6, fontSize: 16, margin: "13px 0" }}><div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
      </div> Procurando endereço...</div>
      }

      {/* Modal — estilo e botão de fechar seguem seu padrão */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <button
          onClick={() => setShowModal(false)}
          className="btn btn-light p-1"
          style={{
            width: 30,
            height: 30,
            position: "absolute",
            right: 6,
            top: 6,
            borderRadius: "100%",
            zIndex: 1051,
          }}
        >
          <i className="bi bi-x-circle" style={{ fontSize: 14 }}></i>
        </button>

        <div
          className="d-flex align-items-center justify-content-center flex-column p-4"
          style={{ minHeight: 200 }}
        >
          <h4 style={{ borderBottom: "1px solid #f1f1f1", paddingBottom: 7 }}>
            <i className="fa-solid fa-location-dot"></i> Endereços encontrados
          </h4>
          <br />
          <div style={{ width: "100%" }}>
            {loading ? (
              <p>Carregando...</p>
            ) : suggestions.length > 0 ? (
              <ul
                className="list-group"
                style={{ maxHeight: 300, overflowY: "auto" }}
              >
                {suggestions.map((item) => (
                  <li
                    key={item.place_id}
                    className="list-group-item list-group-item-action"
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                    }}
                    onClick={() => (handleSelect(item) , setShowModal(false))}
                  >
                    <i className="bi bi-geo-alt" style={{ fontSize: 18 }} />
                    <div style={{ lineHeight: 1.1 }}>
                      {formatAddress(item, extractNumberFromQuery(query))}
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p>Nenhum endereço encontrado.</p>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};